// we should make something better, but for now...
export const zIndexHomeNav = 10;

export const zIndexWeekLoading = 10;
export const zIndexsettingsDrawer = 11;
